import { render, staticRenderFns } from "./FilterCompanies.vue?vue&type=template&id=54339228&lang=pug"
import script from "./FilterCompanies.vue?vue&type=script&lang=js"
export * from "./FilterCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports